// "catchApiError" to the catch block of all web services
export const catchApiError = (e: unknown) => {
  // eslint-disable-next-line no-console
  console.error(e)
  if (typeof e === 'object' && 'response' in e) {
    throw e.response
  }
  throw new Error(String(e))
}
